<header class="page-header">
  <h1 class="page-header__title">{{ title }}</h1>
  <p class="page-header__desc" *ngIf="description">{{ description }}</p>
  <div class="page-header__actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</header>
